import { render, staticRenderFns } from "./ProfitProduct.vue?vue&type=template&id=11ed497d&scoped=true"
import script from "./ProfitProduct.vue?vue&type=script&lang=js"
export * from "./ProfitProduct.vue?vue&type=script&lang=js"
import style0 from "./ProfitProduct.vue?vue&type=style&index=0&id=11ed497d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed497d",
  null
  
)

export default component.exports